(function () {
    'use strict';

    angular
        .module('core.services')
        .service('HelperService', HelperService)

    /** @ngInject */
    function HelperService(_, $timeout, $state, $rootScope, $q, sweetAlert, ValidationMessageService, NotifyService, AuthenticationService, AUTH_EVENTS, ROUTES, LOCAL_STORAGE_ITEMS) {
        const HelperService = {
            tryParseJSON: tryParseJSON,
            handleOnRun: handleOnRun,
            handleLocationChangeStart: handleLocationChangeStart,
            handleStateChangeStart: handleStateChangeStart,
            handleStateChangeSuccess: handleStateChangeSuccess,
            handleStateChangeError: handleStateChangeError,
            handleViewContentLoaded: handleViewContentLoaded,
            errorCallback: errorCallback,
            successCallback: successCallback,
            startLoading: startLoading,
            stopLoading: stopLoading,
            setErrorMessageForm: setErrorMessageForm,
            removeErrorMessageForm: removeErrorMessageForm,
            isScreenSmaller: isScreenSmaller,
            getFlowOptionsDefaults: getFlowOptionsDefaults,
            getFlowOptionsDefaultsVideoUpload: getFlowOptionsDefaultsVideoUpload,
            getFlowOptionsDefaultsGallery: getFlowOptionsDefaultsGallery,
            getFlowOptionsDefaultsPaymentSlip: getFlowOptionsDefaultsPaymentSlip,
            getFlowOptionsDefaultsJuridical: getFlowOptionsDefaultsJuridical,
            imageHandlerPath: imageHandlerPath,
            imageResizePath: imageResizePath,
            validateCPF: validateCPF,
            uiCanExit: uiCanExit,
            getMomentDate: getMomentDate
        };

        return HelperService;

        function getFlowOptionsDefaults() {
            const token = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
            let headers = {};

            if (token)
                headers['Authorization'] = 'Bearer ' + token;

            return {
                permanentErrors: [500, 501, 428],
                maxChunkRetries: 1,
                chunkRetryInterval: 5000,
                simultaneousUploads: 1,
                allowDuplicateUploads: true,
                singleFile: true,
                target: `${ROUTES.API}/images/upload`,
                headers: headers
            }
        }

        function getFlowOptionsDefaultsGallery() {
            const token = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
            let headers = {};

            if (token)
                headers['Authorization'] = 'Bearer ' + token;

            return {
                permanentErrors: [500, 501, 428],
                maxChunkRetries: 1,
                chunkRetryInterval: 5000,
                allowDuplicateUploads: true,
                simultaneousUploads: 5,
                target: `${ROUTES.API}/images/upload`,
                headers: headers
            }
        }

        function getFlowOptionsDefaultsVideoUpload() {
            const token = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
            let headers = {};

            if (token)
                headers['Authorization'] = 'Bearer ' + token;

            return {
                permanentErrors: [500, 501, 428],
                maxChunkRetries: 1,
                chunkRetryInterval: 5000,
                simultaneousUploads: 1,
                allowDuplicateUploads: true,
                singleFile: true,
                target: `${ROUTES.API}/videos/upload`,
                headers: headers
            }
        }

        function getFlowOptionsDefaultsPaymentSlip() {
            const token = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
            let headers = {};

            if (token)
                headers['Authorization'] = 'Bearer ' + token;

            return {
                permanentErrors: [500, 501, 428],
                maxChunkRetries: 1,
                chunkRetryInterval: 5000,
                simultaneousUploads: 1,
                allowDuplicateUploads: true,
                singleFile: true,
                target: `${ROUTES.API}/payment/upload`,
                headers: headers
            }
        }

        function getFlowOptionsDefaultsJuridical() {
            const token = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
            let headers = {};

            if (token)
                headers['Authorization'] = 'Bearer ' + token;

            return {
                permanentErrors: [500, 501, 428],
                maxChunkRetries: 1,
                chunkRetryInterval: 5000,
                simultaneousUploads: 1,
                allowDuplicateUploads: true,
                singleFile: true,
                target: `${ROUTES.API}/juridical/upload`,
                headers: headers
            }
        }

        function imageHandlerPath(area, id, file) {
            return `${ROUTES.API}/images/res/${area}/${id}/${file}`;
        }

        function imageResizePath(area, id, file, width, height) {
            return `${ROUTES.API}/images/res/${width}/${height}/${area}/${id}/${file}`;
        }

        function validateCPF(cpf) {
            let sum = 0;
            let rest;

            if (cpf == '00000000000') return false;

            for (i = 1; i <= 9; i++)
                sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);

            rest = (sum * 10) % 11;

            if ((rest == 10) || (rest == 11))
                rest = 0;

            if (rest != parseInt(cpf.substring(9, 10)))
                return false;

            sum = 0;

            for (i = 1; i <= 10; i++)
                sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);

            rest = (sum * 10) % 11;

            if ((rest == 10) || (rest == 11))
                rest = 0;

            if (rest != parseInt(cpf.substring(10, 11)))
                return false;

            return true;
        }

        function uiCanExit(originalData, compareData) {
            let defer = $q.defer();

            let showModal = () => {
                sweetAlert.swal({
                    title: 'Você tem certeza?',
                    text: 'Você irá perder as alterações que executou',
                    type: 'warning',
                    confirmButtonText: 'Sim, tenho certeza',
                    showCancelButton: true,
                    cancelButtonText: 'Não, cancelar',
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    if (response.value)
                        defer.resolve(true);
                    else
                        defer.resolve(false);
                })
            }

            if (originalData && originalData.constructor === Array && compareData && compareData.constructor === Array) {
                let hasDiff = false;

                for (let index = 0; index < originalData.length; index++) {
                    const data = originalData[index];

                    if (compareData[index] && !angular.equals(data, compareData[index])) {
                        // var result = deepDiffMapper.map(data, compareData[index]);
                        // var result2 = getObjectDiff(data, compareData[index]);
                        // console.log('result: ', result);
                        // console.log('result2: ', result2);

                        hasDiff = true;
                        showModal();
                    }
                }

                if (!hasDiff)
                    defer.resolve(true);
            } else {
                if (!angular.equals(originalData, compareData))
                    showModal();
                else
                    defer.resolve(true);
            }

            return defer.promise;
        }

        /*
         * Compare two objects by reducing an array of keys in obj1, having the
         * keys in obj2 as the intial value of the result. Key points:
         *
         * - All keys of obj2 are initially in the result.
         *
         * - If the loop finds a key (from obj1, remember) not in obj2, it adds
         *   it to the result.
         *
         * - If the loop finds a key that are both in obj1 and obj2, it compares
         *   the value. If it's the same value, the key is removed from the result.
         */
        function getObjectDiff(obj1, obj2) {
            const diff = Object.keys(obj1).reduce((result, key) => {
                if (!obj2.hasOwnProperty(key)) {
                    result.push(key);
                } else if (_.isEqual(obj1[key], obj2[key])) {
                    const resultKeyIndex = result.indexOf(key);
                    result.splice(resultKeyIndex, 1);
                }
                return result;
            }, Object.keys(obj2));

            return diff;
        }

        /**
         * Tries to parse a JSON string
         *
         * @param {string} jsonString - String to be parsed
         */
        function tryParseJSON(jsonString) {
            try {
                var o = JSON.parse(jsonString);

                // Handle non-exception-throwing cases:
                // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
                // but... JSON.parse(null) returns null, and typeof null === "object",
                // so we must check for that, too. Thankfully, null is falsey, so this suffices:
                if (o && typeof o === 'object')
                    return o;
            } catch (e) {
                return false;
            }

            return false;
        }

        /**
         * Auxiliar method to prevent state and location change if there's a sweet alert modal open
         *
         * @param {object} event - The current event
         */
        function handleLocationChangeStart(event) {
            if ($rootScope.isSweetAlertModalOpen)
                event.preventDefault();
        }

        /**
         * Auxiliar method to execute the necessary methods on the route change start
         *
         * @param {object} transition - The executing transition
         */
        function handleStateChangeStart(transition) {
            $rootScope.alignLayoutCenter = false;

            const nextUrl = transition.to().url;

            if (transition.to().name.indexOf('app-auth') >= 0)
                return transition;

            if ((nextUrl.indexOf('not-authorized') >= 0 || nextUrl.indexOf('opening-process') >= 0) && AuthenticationService.isLogged())
                return transition;

            if (!AuthenticationService.isLogged()) {
                AuthenticationService.logout();
                return false;
            }

            if (!AuthenticationService.canAccess(transition.to()))
                return transition.router.stateService.transitionTo('app.not-authorized');

            if (isScreenSmaller(991) && $('body').hasClass('menu-fixed'))
                $rootScope.menuOpen = false;

            AuthenticationService.configureUserPermissions(transition.to());

            return transition;
        }

        /**
         * Auxiliar method executed on every route state successfull change
         */
        function handleStateChangeSuccess() {
            $('.modal-backdrop').remove();

            // $window.ga('send', 'pageview', {
            //     page: $location.url()
            // });

            document.body.scrollTop = document.documentElement.scrollTop = 0;
        }

        /**
         * Auxiliar method executed once the system has finished loading all of it's content
         */
        function handleViewContentLoaded() {
            // $('[data-toggle=tooltip]').tooltip('enable');
        }

        /**
         * Auxiliar method executed when the system is starting
         */
        function handleOnRun() {
            //Comment this to exit errors related to transition and/or transition related services like User or Menu
            // $state.defaultErrorHandler(angular.noop);

            // NotificationService.initNotifications();

            $rootScope.isSweetAlertModalOpen = false;
            $rootScope.removeMessage = removeErrorMessageForm;

            $rootScope.isMobile = isScreenSmaller(991);

            $rootScope.currentYear = moment().format('YYYY');
            $rootScope.ValidationMessage = ValidationMessageService.getMessage;

            $rootScope.$on(AUTH_EVENTS.NOT_AUTHENTICATED, AuthenticationService.logout);
        }

        /**
         * Auxiliar method executed when the route change fails
         *
         * @param {object} error - The transition error
         */
        function handleStateChangeError(error) {
            if (error && error.redirTo)
                $state.go(error.redirTo);
        }

        function isScreenSmaller(size) {
            return Modernizr.mq(`(max-width: ${size}px)`);
        }

        function errorCallback(error) {
            let message = 'Ocorreu um erro inesperado, por favor tente novamente!';

            if (error && error.data && error.data.ErrorCode) {
                if (error.data.ErrorCode == 403 || error.data.ErrorCode == 404 || error.data.ErrorCode == 409)
                    message = error.data.ErrorMessage || 'Ocorreu um erro inesperado, por favor tente novamente!';

                else if (error.data.ErrorCode == 422) {
                    const errorMessage = error.data.ErrorMessage;
                    let parsedErrorMessage;

                    if (typeof errorMessage === 'string')
                        parsedErrorMessage = tryParseJSON(errorMessage);

                    if (typeof parsedErrorMessage === typeof []) {
                        let messages = parsedErrorMessage;
                        message = '';

                        if (messages) {
                            for (let i = 0; i < messages.length; i++)
                                message += messages[i].ErrorMessage;
                        }
                    } else
                        message = errorMessage;
                }
            } else if (error && error.data && error.data.error && error.data.error_description) {
                if (error.data.error == 'invalid_grant')
                    message = error.data.error_description;
            }

            NotifyService.error(message);
        }

        function successCallback(type = 'create') {
            let message = '';

            if (type == 'create')
                message = 'Registro salvo com sucesso';

            else if (type == 'update')
                message = 'Registro atualizado com sucesso';

            else if (type == 'delete')
                message = 'Registro apagado com sucesso';

            else if (type == 'image')
                message = 'Imagem salva com sucesso'

            NotifyService.success(message);
        }

        function startLoading(element, smaller = false) {
            $timeout(() => {
                let widget = $(element).closest('[data-widget]');
                let smallerClass = '';

                if ($(element).attr('[data-widget]'))
                    widget = $(element);

                if (smaller)
                    smallerClass = 'smaller';

                widget.append(`<div class="loading-body ${smallerClass}">
                                <img src="app/dist/images/progress-circle-complete.svg" alt="Carregando, aguarde...">
                            </div>`);
            })
        }

        function stopLoading(element) {
            $timeout(() => {
                let widget = $(element).closest('[data-widget]');

                if ($(element).attr('[data-widget]'))
                    widget = $(element);

                widget
                    .find('.loading-body')
                    .fadeOut(() => {
                        $(this).remove();
                    });
            })
        }

        function setErrorMessageForm(input, text = null, centerElement = false) {
            if (!$(input).parent().find('.validationMessage').length) {

                let errorText = "Este campo é Obrigatório"
                let centerClass = "";

                if (text != null)
                    errorText = text;

                if (centerElement)
                    centerClass = "text-center";

                $(input).parent()
                    .append(`<label class=\'control-label has-error validationMessage ${centerClass}\'>${errorText}</label>`);

                $(input)
                    .addClass('has-error')
                    .parents('.form-group')
                    .addClass('has-error');
            }

            $([document.documentElement, document.body]).animate({
                scrollTop: $(input).offset().top - ($('.header').outerHeight() + 30)
            }, 600);
        }

        function removeErrorMessageForm(input) {
            $(input)
                .parent()
                .find('.validationMessage')
                .remove();

            $(input)
                .removeClass('has-error')
                .parents('.form-group')
                .removeClass('has-error');
        }

        function getMomentDate(date) {
            let dateReplaced = date.replace(/[//"]/g, '-');
            let dateSplitted = dateReplaced.split("-");

            let finalDate = `${dateSplitted[2]}-${dateSplitted[1]}-${dateSplitted[0]}`;

            return moment(finalDate);
        }
    }
}());
